import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "px-default md:hidden" }
const _hoisted_2 = { class: "py-4 flex gap-3 w-full overflow-auto" }
const _hoisted_3 = { class: "icon relative z-10" }
const _hoisted_4 = { class: "font-semibold relative z-10" }

import { categories } from "@/data/data";
import { Icon } from "@iconify/vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'MobileCategories',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categories), (category, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: category.name
        }, [
          _createVNode(_component_RouterLink, {
            to: 
            index !== 0
              ? {
                  name: 'Category',
                  params: {
                    category: category.name.toLowerCase(),
                  },
                }
              : '/'
          ,
            class: "sidebar-link"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_unref(Icon), {
                  icon: category.icon,
                  class: "text-4xl"
                }, null, 8, ["icon"])
              ]),
              _createElementVNode("p", _hoisted_4, _toDisplayString(category.name), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ]))
      }), 128))
    ])
  ]))
}
}

})